import React, { Component, Fragment } from "react";
import "./App.css";

import ship_brown from "./icons/ship_brown.png";
import ship_red from "./icons/ship_red.png";
import ship_green from "./icons/ship_green.png";
import ship_yellow from "./icons/ship_yellow.png";
import ship_maroon from "./icons/ship_maroon.png";
import ship_pink from "./icons/ship_pink.png";
import ship_lime from "./icons/ship_lime.png";

import ship_brown_flip from "./icons/ship_brown_flip.png";
import ship_red_flip from "./icons/ship_red_flip.png";
import ship_green_flip from "./icons/ship_green_flip.png";
import ship_yellow_flip from "./icons/ship_yellow_flip.png";
import ship_maroon_flip from "./icons/ship_maroon_flip.png";
import ship_pink_flip from "./icons/ship_pink_flip.png";
import ship_lime_flip from "./icons/ship_lime_flip.png";

import shipSVG from "./icons/shipSVG.svg";
import cayoLargo from "./icons/cayoLargo.jpg";
import gGivesTeam from "./icons/gGivesTeam.png";
import portAnchor from "./icons/portAnchorBlue.png";

import MenuIcon from "./MenuIcon.js";

import MCUtil from "./MCUtil.js";

var moment = require("moment-timezone");
moment.tz.add(
  "America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5"
);
window.moment = moment;

var getFerryPositionsUrl =
  "https://li441qdqee.execute-api.us-west-1.amazonaws.com/beta";

var createReactClass = require("create-react-class");
var d3 = require("d3");

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
};

var App = createReactClass({
  getInitialState: function () {
    var state = {
      mounted: false,
      selectionType: "boat", //boat or port
      selectedBoat: 0,
      selectedPort: 0,
      boatList: [],
      portList: [],
      boatMap: {},
      portMap: {},
      navShown: false,
      showSubMenu: false,
      showConfirmationCode: false,
      onPage: 0,
      alertHours: 1,
    };

    state.endpointType = 0;
    state.endpoint = "";
    state.expireHours = 0;
    state.topic = "";
    state.confirmationCode = "";

    state.subOrUnsub = 0;

    return state;
  },
  setTopic: function (topic, isSubscribe) {
    if (!topic) {
      return;
    }

    var state = this.state;

    state.topic = topic;
    state.showSubMenu = true;
    state.subOrUnsub = isSubscribe ? 1 : 2;

    this.setState(state);
  },
  subscribeClick: function (isSubscribe) {
    var topic = "";
    if (this.state.selectionType == "boat") {
      switch (parseInt(this.state.boatList[this.state.selectedBoat].MMSI)) {
        case 338173000:
          topic = "mrcade";
          break;
        case 368237000:
          topic = "cayolargo";
          break;
        case 367618070:
          topic = "cayoblanco";
          break;
        case 366915910:
          topic = "bigcatexpress";
          break;
        case 367481080:
          topic = "mrmason";
          break;
        case 367547820:
          topic = null; //was isla bonita
          break;
        case 368038790:
          topic = "schoodicexplorer";
          break;
        case 367618240:
          topic = "mrevan";
          break;
        case 367617270:
          topic = "isleno";
          break;
        case 368106360:
          topic = "coastalexplorer";
          break;
        case 368087510:
          topic = "julialeigh";
          break;
        case 368037610:
          topic = "breezypoint";
          break;
        case 368038080:
          topic = "summerwind";
          break;
        case 367396890:
          topic = "mitchel";
          break;
        case 367757210:
          topic = "donjamie";
          break;
        case 367179790:
          topic = "ladyeve";
          break;
        case 368054610:
          topic = "straitsexpress";
          break;
        case 368014910:
          topic = "aurora";
          break;
        case 367495520:
          topic = "mrrow";
          break;
        case 367617230:
          topic = "santamaria";
          break;
        case 368404080:
          topic = "laborinquena";
          break;
        default:
          topic = null;
          break;
      }
    } else {
      switch (this.state.portList[this.state.selectedPort].name) {
        case "Vieques Ferry Terminal":
          topic = "vieques";
          break;
        case "Ceiba Ferry Terminal":
          topic = "ceiba";
          break;
        case "Fajardo Ferry Terminal":
          topic = "fajardo";
          break;
        case "Terminal de Lanchas de Culebra":
          topic = "culebra";
          break;
        default:
          topic = null;
          break;
      }
    }

    console.log(isSubscribe ? "Subscribe to " : "Unsubscribe from ", topic);
    this.setTopic(topic, isSubscribe);
  },
  startSubUnsub: function (isSubscribe) {
    var createD = new Date();

    if (!MCUtil.formatPhoneNumber(this.state.endpoint, true)) {
      alert("Please enter a valid US phone number!");
      return;
    }

    var url = null;
    if (isSubscribe) {
      url =
        "https://8junzytzvk.execute-api.us-west-1.amazonaws.com/StartSubStage";
    } else {
      url =
        "https://ca6cz2kqn0.execute-api.us-west-1.amazonaws.com/StartUnsubStage";
    }

    var data = {};

    data.endpointType = 0;
    data.endpoint = "1" + MCUtil.formatPhoneNumber(this.state.endpoint, true);
    data.createDate = createD.getTime() / 1000; // milliseconds since Jan 1, 1970, 00:00:00.000 GMT
    data.expireDate = isSubscribe
      ? createD.getTime() / 1000 + 60 * 60 * this.state.alertHours
      : createD.getTime() / 1000;
    data.topic = this.state.topic;

    console.log(data);

    this.setState({
      showSubPleaseWait: true,
    });

    MCUtil.sendXHR(
      url,
      JSON.stringify(data),
      "POST",
      "application/json",
      after.bind(this),
      fail.bind(this),
      isSubscribe ? "Start Sub" : "Start Unsub",
      null
    );

    function after(xhr) {
      console.log(xhr.response);
      if (
        (xhr.status == 200 &&
          xhr.response ==
            '"Please enter the confirmation code send to the number provided"') ||
        xhr.response ==
          '"Please enter the code send to the number provided to unsubscribe."'
      ) {
        this.setState({
          showConfirmationCode: true,
          showSubPleaseWait: false,
          subUnsubData: data.clone(),
          subUnsubStarted: true,
        });
      }
    }

    function fail(xhr) {
      console.log(xhr);
    }
  },
  confirmSubscription: function (isSubscribe) {
    var data = this.state.subUnsubData;
    data.confirmationCode = this.state.confirmationCode;

    var url = null;
    if (isSubscribe) {
      url =
        "https://7rjmioechi.execute-api.us-west-1.amazonaws.com/CreateSubStage";
    } else {
      url =
        "https://3mbhmk70y3.execute-api.us-west-1.amazonaws.com/DeleteSubStage";
    }

    this.setState({
      showSubPleaseWait: true,
    });

    MCUtil.sendXHR(
      url,
      JSON.stringify(data),
      "POST",
      "application/json",
      after.bind(this),
      fail.bind(this),
      isSubscribe ? "Create Sub" : "Delete Sub",
      null
    );

    function after(xhr) {
      console.log(xhr);
      console.log(xhr.response);
      this.setState(
        {
          subUnsubMessage: isSubscribe
            ? "Subscribe successful"
            : "Unsubscribe successful",
          showSubPleaseWait: false,
          showConfirmationCode: false,
          subUnsubStarted: false,
        },
        after2.bind(this)
      );
      function after2() {
        window.setTimeout(
          function () {
            this.setState({
              showSubMenu: false,
            });
          }.bind(this),
          1000
        );
      }
    }

    function fail(xhr) {
      console.log(xhr);
      this.setState({
        subUnsubMessage: isSubscribe
          ? "Error subscribing"
          : "Error unsubscribing",
        showSubPleaseWait: false,
        showConfirmationCode: false,
        subUnsubStarted: false,
      });
    }
  },
  preventSubmit: function (evt) {
    evt.preventDefault();
  },
  cancelSubscribe: function () {
    this.setState({
      showSubMenu: false,
      endpoint: "",
      confirmationCode: "",
      subOrUnsub: 0,
      showConfirmationCode: false,
      subUnsubData: null,
      subUnsubMessage: null,
      subUnsubStarted: false,
    });
  },
  buildSubscribe: function () {
    console.log(this.state.endpoint);
    if (this.state.selectionType === "boat") {
      var boat = this.state.boatList[this.state.selectedBoat];
    }
    return (
      <Fragment>
        {this.state.selectionType == "boat" ? (
          <div className="property major" style={{ marginTop: "0.5rem" }}>
            <form>
              <div className="f-label">
                Boat:
                <img
                  className="port-ship-icon ship-svg"
                  src={this.assignIcon(boat.MMSI)}
                />
              </div>
              <select
                className="phone-email-input"
                value={this.state.selectedBoat}
                onChange={this.changeSelection}
              >
                {this.buildBoatSelectionOptions()}
              </select>
            </form>
          </div>
        ) : null}
        {this.state.selectionType == "port" ? (
          <div className="property major" style={{ marginTop: "0.5rem" }}>
            <form>
              {/* <div className="f-label">Port:<img className="port-ship-icon ship-svg" src={shipSVG}/></div> */}
              <div className="f-label">Port:</div>
              <select
                className="phone-email-input"
                value={this.state.selectedPort}
                onChange={this.changeSelection}
              >
                {this.buildPortSelectionOptions()}
              </select>
            </form>
          </div>
        ) : null}
        <div className="property major">
          <form onSubmit={this.preventSubmit}>
            <div className="f-label">Phone Number:</div>
            <div className="phone-prefix">+1</div>
            <input
              className="phone-email-input with-prefix"
              value={MCUtil.formatPhoneNumber(this.state.endpoint)}
              onChange={this.changeEndpoint}
            />
          </form>
        </div>
        {this.state.subOrUnsub == 1 ? (
          <div className="property major">
            <form onSubmit={this.preventSubmit}>
              <div className="f-label">Subscribe For:</div>
              {/* <input className="phone-email-input" min={1} max={720} type="number" value={this.state.alertHours} onChange={this.changeHours}/> */}
              <select
                className="phone-email-input"
                value={this.state.alertHours}
                onChange={this.changeHours}
              >
                <option value={1}>1 Hour</option>
                <option value={2}>2 Hours</option>
                <option value={3}>3 Hours</option>
                <option value={6}>6 Hours</option>
                <option value={12}>12 Hours</option>
                <option value={24}>1 Day</option>
                <option value={48}>2 Days</option>
                <option value={168}>1 Week</option>
              </select>
            </form>
            <div className="alert">
              Please unsubscribe through this website and NOT through text if
              you wish to do so. Unsubscribing through text may prevent future
              subscriptions by our messaging provider.
            </div>
          </div>
        ) : null}
        {this.state.showConfirmationCode ? (
          <div className="property major">
            <form onSubmit={this.preventSubmit}>
              <div className="f-label">Confirmation Code:</div>
              <input
                className="phone-email-input"
                value={this.state.confirmationCode}
                onChange={this.changeConfirmationCode}
              />
            </form>
          </div>
        ) : null}
        {this.state.showSubPleaseWait ? (
          <div className="please-wait">Please wait...</div>
        ) : null}
        {this.state.subUnsubMessage ? (
          <div className="sub-unsub-message">{this.state.subUnsubMessage}</div>
        ) : null}
        {/* <div className="property major">
            <form>
              <div className="f-label">Email:</div>
              <input className="phone-email-input" value={this.state.endpoint2} onChange={this.changeEndpoint}/>
            </form>
          </div> */}
      </Fragment>
    );
  },
  changeConfirmationCode: function (evt) {
    this.setState({
      confirmationCode: evt.target.value,
    });
  },
  changeEndpoint: function (evt) {
    this.setState({
      endpoint: evt.target.value,
    });
  },
  changeHours: function (evt) {
    var num = parseInt(evt.target.value);
    if (num < 1) {
      num = 1;
    } else if (num > 720) {
      num = 720;
    }
    this.setState({
      alertHours: num,
    });
  },
  componentDidUpdate: function () {
    //testing change
    var x = "some var";
  },
  changeSelection: function (evt) {
    console.log(evt.target.value);
    if (this.state.selectionType == "boat") {
      this.boatMarkerClick(parseInt(evt.target.value));
    } else {
      this.state.portIconArr[evt.target.value].openPopup();
      this.moveMapTo(this.state.portIconArr[evt.target.value].getLatLng());
      this.setState({
        selectedPort: evt.target.value,
      });
    }
  },
  buildBoatSelectionOptions: function () {
    var ops = [];
    for (var i = 0; i < this.state.boatList.length; i++) {
      var b = this.state.boatList[i];
      ops.push(
        <option key={i.toString()} value={i}>
          {b.SHIP_NAME}
        </option>
      );
    }
    var opsFrag = <Fragment>{ops}</Fragment>;
    return opsFrag;
  },
  buildPortSelectionOptions: function () {
    var ops = [];
    for (var i = 0; i < this.state.portList.length; i++) {
      var p = this.state.portList[i];
      ops.push(
        <option key={i.toString()} value={i}>
          {p.name}
        </option>
      );
    }
    var opsFrag = <Fragment>{ops}</Fragment>;
    return opsFrag;
  },
  portIconClick: function (evt) {
    var n = evt.target.getAttribute("data-portname");
    for (var i = 0; i < this.state.portList.length; i++) {
      if (this.state.portList[i].name == n) {
        this.state.portIconArr[i].openPopup();
        this.moveMapTo(this.state.portIconArr[i].getLatLng());
        this.setState({
          selectedPort: i,
          selectionType: "port",
        });
        break;
      }
    }
  },
  shipIconClick: function (evt) {
    var n = evt.target.getAttribute("data-mmsi");
    for (var i = 0; i < this.state.boatList.length; i++) {
      console.log(
        this.state.boatList[i].MMSI,
        n,
        this.state.boatList[i].MMSI == n
      );
      if (this.state.boatList[i].MMSI == n) {
        this.state.boatMap[n].icon.openPopup();
        this.moveMapTo(this.state.boatMap[n].icon.getLatLng());
        this.setCompassNeedle(this.state.boatList[i]);
        this.setState({
          selectedBoat: i,
          selectionType: "boat",
        });
        break;
      }
    }
  },
  renderDetails: function () {
    if (!this.state.mounted) {
      return null;
    }
    if (this.state.selectionType === "boat") {
      var boat = this.state.boatList[this.state.selectedBoat];
      return (
        <Fragment>
          <div className="property major">
            <form>
              <div className="f-label">
                Boat:
                <img
                  className="port-ship-icon ship-svg"
                  src={this.assignIcon(boat.MMSI)}
                />
              </div>
              <select
                className="phone-email-input"
                value={this.state.selectedBoat}
                onChange={this.changeSelection}
              >
                {this.buildBoatSelectionOptions()}
              </select>
            </form>
          </div>
          {boat.CURRENTTRIPSTEP == 0 ? (
            <div className="property major">
              <div className="property-title">Stopped At:</div>
              <div className="property-body">
                <div className="property-value iconed">
                  {"Port: " + boat.ATPORT}
                  <img
                    className="port-ship-icon"
                    data-portname={boat.ATPORT}
                    onClick={this.portIconClick}
                    src={portAnchor}
                  />
                </div>
                <div className="property-value">
                  {"Arrived: " + boat.STARTTIME}
                </div>
              </div>
            </div>
          ) : null}
          {boat.CURRENTTRIPSTEP > 0 ? (
            <div className="property major">
              <div className="property-title">Departure:</div>
              <div className="property-body">
                <div className="property-value iconed">
                  {"Port: " + boat.ATPORT}
                  <img
                    className="port-ship-icon"
                    data-portname={boat.ATPORT}
                    onClick={this.portIconClick}
                    src={portAnchor}
                  />
                </div>
                <div className="property-value">
                  {"Time: " + boat.STARTTIME}
                </div>
              </div>
            </div>
          ) : null}
          {boat.CURRENTTRIPSTEP > 0 ? (
            <div className="property major">
              <div className="property-title">Destination:</div>
              <div className="property-body">
                <div className="property-value iconed">
                  {"Port: " + boat.TOPORT}
                  <img
                    className="port-ship-icon"
                    data-portname={boat.TOPORT}
                    onClick={this.portIconClick}
                    src={portAnchor}
                  />
                </div>
                <div className="property-value">
                  {"ETA: " + boat.ETAMIN + " - " + boat.ETAMAX}
                </div>
              </div>
            </div>
          ) : null}
          {boat.CURRENTTRIPSTEP > 0 ? (
            <div className="property major">
              <div className="property-title">Speed:</div>
              <div className="property-body">
                <div className="property-value">
                  {parseFloat(boat.SPEED) / 10 + " KNOTS"}
                </div>
              </div>
            </div>
          ) : null}
          {/* {(boat.CURRENTTRIPSTEP) > 0 ? <div className="property major">
            <div className="property-title">Course:</div>
            <div className="property-body">
              <div className="property-value">
                {boat.COURSE}
              </div>
            </div>
          </div> : null} */}
          <div className="property major">
            <div className="property-title">Received:</div>
            <div className="property-body">
              <div className="property-value">{boat.TIMESTAMP}</div>
              {this.isStale(boat) > 20 ? (
                <div className="stale">
                  {"Last received over 20 minutes ago."}
                </div>
              ) : null}
            </div>
          </div>
        </Fragment>
      );
    } else if (this.state.selectionType == "port") {
      var port = this.state.portList[this.state.selectedPort];
      return (
        <Fragment>
          <div className="property major">
            <form>
              {/* <div className="f-label">Port:<img className="port-ship-icon ship-svg" src={shipSVG}/></div> */}
              <div className="f-label">Port:</div>
              <select
                className="phone-email-input"
                value={this.state.selectedPort}
                onChange={this.changeSelection}
              >
                {this.buildPortSelectionOptions()}
              </select>
            </form>
          </div>
          {port.inbound.length > 0 ? (
            <div className="property major">
              <div className="property-title">Inbound:</div>
              <div className="property-body">{this.buildInbound(port)}</div>
            </div>
          ) : null}
          {port.docked.length > 0 ? (
            <div className="property major">
              <div className="property-title">Docked:</div>
              <div className="property-body">{this.buildDocked(port)}</div>
            </div>
          ) : null}
          {port.outbound.length > 0 ? (
            <div className="property major">
              <div className="property-title">Outbound:</div>
              <div className="property-body">{this.buildOutbound(port)}</div>
            </div>
          ) : null}
        </Fragment>
      );
    }
  },
  buildInbound: function (port) {
    var arr = [];
    for (var i = 0; i < port.inbound.length; i++) {
      var ship = port.inbound[i];
      arr.push(
        <Fragment key={i}>
          <div className="property-value iconed">
            {"Ship: " + ship.shipname}
            <img
              className="port-ship-icon"
              data-mmsi={ship.mmsi}
              onClick={this.shipIconClick}
              src={this.assignIcon(ship.mmsi, 0)}
            />
          </div>
          <div className="property-value">
            {"ETA: " + ship.etamin + " - " + ship.etamax}
          </div>
          {i == port.inbound.length - 1 ? null : <div className="spacer"></div>}
        </Fragment>
      );
    }
    return arr;
  },
  buildDocked: function (port) {
    var arr = [];
    for (var i = 0; i < port.docked.length; i++) {
      var ship = port.docked[i];
      arr.push(
        <Fragment key={i}>
          <div className="property-value iconed">
            {"Ship: " + ship.shipname}
            <img
              className="port-ship-icon"
              data-mmsi={ship.mmsi}
              onClick={this.shipIconClick}
              src={this.assignIcon(ship.mmsi, 0)}
            />
          </div>
          <div className="property-value">{"Arrived: " + ship.starttime}</div>
          {i == port.docked.length - 1 ? null : <div className="spacer"></div>}
        </Fragment>
      );
    }
    return arr;
  },
  buildOutbound: function (port) {
    var arr = [];
    for (var i = 0; i < port.outbound.length; i++) {
      var ship = port.outbound[i];
      arr.push(
        <Fragment key={i}>
          <div className="property-value iconed">
            {"Ship: " + ship.shipname}
            <img
              className="port-ship-icon"
              data-mmsi={ship.mmsi}
              onClick={this.shipIconClick}
              src={this.assignIcon(ship.mmsi, 0)}
            />
          </div>
          <div className="property-value">{"Departed: " + ship.starttime}</div>
          <div className="property-value">{"Destination: " + ship.toport}</div>
          {/* <img className="port-ship-icon" src={this.assignIcon(ship.mmsi, 0)}/> */}
          {i == port.outbound.length - 1 ? null : (
            <div className="spacer"></div>
          )}
        </Fragment>
      );
    }
    return arr;
  },
  openGenGives: function () {
    window.open("https://www.generationgives.org", "_blank");
  },
  radioChange: function (changeEvent) {
    this.setState({
      selectionType: changeEvent.target.value,
    });
  },
  render: function () {
    var s = {
      height: "calc(100vh - 48px)",
      width: "calc(100vw - 300px)",
      marginLeft: "300px",
      marginTop: "-1px",
      position: "relative",
      display: "block",
      outline: "none",
      overflow: "hidden",
    };

    var boat = this.state.boatList[this.state.selectedBoat];
    var showComp = false;
    if (boat && boat.CURRENTTRIPSTEP > 0) {
      showComp = true;
    }

    return (
      <div className="App">
        <div
          id="map-app-header"
          className={this.state.onPage == 1 ? "about" : ""}
        >
          <svg
            onClick={this.setPage.bind(this, 0)}
            className="g-gives-svg"
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 536.000000 526.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <g
              transform="translate(0.000000,526.000000) scale(0.100000,-0.100000)"
              fill="#ffffff"
              stroke="none"
            >
              <path
                d="M2400 5250 c-213 -20 -454 -67 -655 -126 -467 -138 -919 -414 -1200
        -732 -85 -96 -251 -330 -241 -339 3 -3 54 24 113 60 135 80 210 118 389 196
        387 167 866 321 1219 390 261 51 260 52 93 -33 -259 -131 -368 -218 -368 -291
        0 -19 0 -19 340 32 433 63 793 138 1000 206 119 40 130 41 245 41 426 -3 1218
        -271 1671 -565 58 -39 108 -68 111 -65 6 6 -86 153 -154 244 -74 99 -295 321
        -398 399 -411 310 -875 494 -1436 569 -136 18 -591 27 -729 14z"
              />
              <path
                d="M3550 4340 c-318 -44 -623 -193 -834 -409 l-59 -60 -61 55 c-266 242
        -648 368 -1061 351 -178 -8 -300 -29 -446 -77 -139 -46 -224 -88 -345 -168
        -397 -267 -660 -689 -730 -1172 -20 -138 -15 -447 9 -575 73 -389 222 -673
        492 -938 204 -202 460 -340 745 -402 103 -23 409 -31 537 -15 318 40 596 173
        829 397 l72 68 58 -53 c168 -153 402 -267 664 -323 91 -20 134 -23 330 -23
        247 0 339 13 522 74 510 171 925 656 1049 1228 30 140 38 472 15 632 -52 355
        -179 635 -408 898 -223 255 -506 424 -826 493 -110 23 -436 35 -552 19z m395
        -512 c268 -44 542 -230 703 -476 118 -182 180 -388 189 -628 9 -231 -23 -392
        -112 -582 -82 -172 -207 -331 -348 -439 -128 -99 -305 -171 -473 -194 -228
        -30 -503 31 -681 152 -68 46 -158 124 -192 168 l-30 38 40 116 c59 172 96 364
        112 584 l4 51 -151 6 c-83 3 -518 8 -967 11 l-816 6 -6 -173 c-4 -95 -7 -208
        -7 -250 l0 -78 248 0 c137 0 445 -3 685 -7 l437 -6 -36 -66 c-102 -187 -258
        -371 -389 -458 -317 -212 -689 -237 -1025 -68 -386 194 -620 599 -620 1071 0
        472 281 918 682 1085 306 127 679 92 945 -89 70 -47 164 -132 193 -173 l21
        -28 -40 -118 c-63 -184 -111 -441 -111 -589 l0 -54 333 0 c182 0 619 -3 970
        -7 l637 -6 0 250 0 250 -676 6 c-372 3 -679 8 -681 11 -9 8 75 156 135 240
        251 351 622 511 1027 444z"
              />
              <path
                d="M321 1193 c137 -229 295 -411 499 -574 383 -307 865 -508 1418 -590
        174 -26 593 -37 779 -20 757 69 1429 379 1855 856 86 96 254 332 244 342 -3 3
        -45 -20 -94 -50 -405 -251 -1305 -565 -1811 -632 -53 -7 -51 -5 101 72 170 87
        233 127 291 182 38 35 67 79 67 101 0 16 -64 12 -252 -15 -512 -75 -910 -156
        -1113 -228 -85 -30 -97 -32 -230 -31 -99 0 -175 7 -260 23 -480 88 -1071 318
        -1422 553 -40 26 -77 48 -83 48 -7 0 -2 -16 11 -37z"
              />
            </g>
          </svg>
          <div className="app-title">PR Ferry</div>
          <div className="title-sub" onClick={this.openGenGives}>
            by Generation Gives
          </div>
          <div
            className={
              "app-nav" +
              (this.state.navShown
                ? this.state.onPage == 1
                  ? " shown about"
                  : " shown"
                : "")
            }
          >
            <div
              onClick={this.setPage.bind(this, 0)}
              className={
                "nav-item" + (this.state.onPage == 0 ? " selected" : "")
              }
            >
              MAP
            </div>
            <div
              onClick={this.setPage.bind(this, 1)}
              className={
                "nav-item" + (this.state.onPage == 1 ? " selected" : "")
              }
            >
              ABOUT
            </div>
            {/* <div className={"nav-item" + (this.state.onPage == 2 ? " selected" : "")}>SCHEDULE</div> */}
          </div>
          {MenuIcon(null, "menu-icon", this.showNav)}
        </div>
        {/* <div id="mymap" style={{"height":"40vh", "width":"100vw"}}></div> */}
        <div id="before-map"></div>
        <div id="mymap" style={s}></div>
        <div className="content">
          <div id="selection-details">
            {this.state.showSubMenu ? null : (
              <div className="property selection-radio-container">
                <div className="selection-radio-div">
                  <input
                    onChange={this.radioChange}
                    type="radio"
                    name="selectionType"
                    value="boat"
                    checked={this.state.selectionType === "boat"}
                  />
                  <label for="huey">Boat</label>
                </div>
                <div className="selection-radio-div">
                  <input
                    onChange={this.radioChange}
                    type="radio"
                    name="selectionType"
                    value="port"
                    checked={this.state.selectionType === "port"}
                  />
                  <label for="dewey">Port</label>
                </div>
              </div>
            )}
            {this.state.showSubMenu
              ? this.buildSubscribe()
              : this.renderDetails()}
          </div>
          <div
            id="compass"
            className={
              showComp &&
              this.state.selectionType == "boat" &&
              !this.state.showSubMenu
                ? "shown"
                : ""
            }
          ></div>
          <div className="spacer"></div>
          <div className="sub-unsub">
            {this.state.mounted &&
            (this.state.subOrUnsub == 0 || this.state.subOrUnsub == 1) ? (
              <button
                onClick={
                  this.state.showSubMenu
                    ? this.state.subUnsubStarted
                      ? this.confirmSubscription.bind(this, true)
                      : this.startSubUnsub.bind(this, true)
                    : this.subscribeClick.bind(this, true)
                }
                className="sub-button"
              >
                SUBSCRIBE
              </button>
            ) : null}
            {this.state.mounted &&
            (this.state.subOrUnsub == 0 || this.state.subOrUnsub == 2) ? (
              <button
                onClick={
                  this.state.showSubMenu
                    ? this.state.subUnsubStarted
                      ? this.confirmSubscription.bind(this, false)
                      : this.startSubUnsub.bind(this, false)
                    : this.subscribeClick.bind(this, false)
                }
                className="sub-button"
              >
                UNSUBSCRIBE
              </button>
            ) : null}
          </div>
          {this.state.showSubMenu ? (
            <button
              onClick={this.cancelSubscribe}
              className="sub-button cancel"
            >
              CANCEL
            </button>
          ) : null}
          {this.state.showSubMenu ? (
            <button onClick={this.showTerms} className="sub-button cancel">
              TERMS AND CONDITIONS
            </button>
          ) : null}
        </div>
        {this.buildAboutSection()}
        <div id="after-about"></div>
        <div
          id="modal-container"
          className={this.state.modalClass}
          onClick={this.state.modalClass === "shown" ? this.closeModal : null}
        >
          {this.buildTermsModal()}
        </div>
      </div>
    );
  },
  stopClick: function (e) {
    e.stopPropagation();
    // e.preventDefault();
  },
  buildTermsModal: function () {
    return (
      <div id="terms-modal" onClick={this.stopClick}>
        <div className="title">Terms and Conditions</div>
        <div className="sub-heading">What Information We Collect and Why?</div>
        <div className="paragraph-content">
          When you fill out a subscription form on PRFerry.org, we collect your
          mobile phone number.<br></br>
          <br></br>
          We do this to allow delivery of the monitored port or vessel alerts
          via text messaging for a set duration of time which you individually
          select.<br></br>
          <br></br>
          Understand that your service provider may charge for receiving text
          alerts, any standard carrier fees for receiving text messages will
          apply to SMS messages you receive through this service. If you wish to
          unsubscribe before you set duration expires, visit www.PRFerry.org and
          click Unsubscribe.<br></br>
          <br></br>
          You may also reply to any text message with the word “Stop”, however,
          unsubscribing via a “Stop” text may prevent future text subscriptions
          from PRFerry.org or impact receipt of other subscription text-based
          alerts delivered through your mobile carrier. We recommend visiting
          www.PRFerry.org and clicking Unsubscribe to end your port or vessel
          alert text message enrollment duration early.<br></br>
        </div>
        <div className="sub-heading">Our use of Google Analytics</div>
        <div className="paragraph-content">
          We use Google Analytics to monitor the PRFerry.org app performance and
          understand how visitors use our website and apps. Google Analytics
          collects your IP address and may use cookies to track your visit. To
          learn more and control Google’s collection of this data,{" "}
          <a
            target="_blank"
            href="https://policies.google.com/technologies/partner-sites"
          >
            read the Google privacy policy and terms
          </a>
          .<br></br>
          <br></br>
          For questions or suggestions please{" "}
          <a href="mailto:support@prferry.org?subject=PRFerry Support Needed">
            email PRFerry Support
          </a>
          .<br />
        </div>
      </div>
    );
  },
  showTerms: function () {
    this.setState({
      modalClass: "shown",
    });
  },
  closeModal: function () {
    this.setState({
      modalClass: "hidden",
    });
  },
  showNav: function () {
    this.setState({
      navShown: !this.state.navShown,
    });
  },
  setPage: function (page) {
    if (page == 0) {
      var element = document.getElementById("mymap");
      element.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    } else if (page == 1) {
      var element = document.getElementById("after-about");
      element.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
    this.setState({
      onPage: page,
      navShown: false,
    });
  },
  buildAboutSection: function () {
    return (
      <Fragment>
        <div id="about-section" className="about-section">
          <div className="about-left">
            <div className="left-top">Today Matters</div>
            <div className="left-bot">
              “The purpose of life is not to be happy. It is to be useful, to be
              honorable, to be compassionate, to have it make some difference
              that you have lived and lived well.”
              <div className="quote-by">- Ralph Waldo Emerson</div>
            </div>
          </div>
          <div className="about-right">
            <div className="ar-section bord-bot">
              <div className="ar-section-title">PR Ferry</div>
              <div className="ar-section-body">
                <div className="ar-section-text">
                  {/* PR Ferry is a volunteer driven effort seeking to reduce the uncertainty around ferry journeys for trips to and from Ceiba, Vieques, and Culebra. The application receives updates approxiamtely every two minutes, which are then used to track and display the ships as well as provide an ETA with ~85% confidence. Users may subscribe to alerts notifying them of arrivals, departures, and corrections regarding a specific port or ship. If users wish to unsubscribe, we ask they do so through this application to avoid being opted out of future subscriptions by our messaging provider. The expected ship routes are gathered through provided itineraries which may be updated without notice. This service is not meant to provide 100% accurate timings, please use with discretion. */}
                  PRFerry.org is a volunteer driven effort seeking to reduce the
                  uncertainty around ferry journeys for trips to and from
                  Culebra, Vieques, and Ceiba. PRFerry.org is not affiliated
                  with any ferry service provider and will continue to be
                  updated when any vessels are added to the fleets servicing
                  Culebra, Vieques, and Ceiba.
                  <br />
                  <br />
                  Using this service, anyone may view live vessel positions or
                  subscribe to text message notifications. Subscribing to
                  notifications by boat or port provides a text message alert as
                  each vessel arrives at a port, departs a port, and when a
                  vessel has passed the half-way point of any predicted journey.
                  You can subscribe or unsubscribe to alerts at any time.
                  <br />
                  <br />
                  The PRFerry.org application receives vessel position updates
                  every few minutes, which are used to track and display any
                  ship position on the map. Using GPS and our pattern
                  recognition software our app attempts to calculate an
                  estimated arrival time of any vessel regardless of published
                  schedule based on each vessel’s current heading and speed.
                  <br />
                  <br />
                  Though PRFerry.org is using the best positioning data
                  available, this volunteer service is not able to provide any
                  guarantee of timing or accuracy of the information presented
                  or shared at any point of use. Please use this service with
                  discretion.
                  <br />
                  <br />
                  For questions or suggestions please{" "}
                  <a href="mailto:support@prferry.org?subject=PRFerry Support Needed">
                    email PRFerry Support
                  </a>
                  .<br />
                  _______
                  <br />
                  <br />
                  PRFerry.org is in no way related to PORFerry.com or any other
                  port authority. Current ferry schedules and online tickets are
                  available at PORFerry.com
                </div>
                <img className="ar-section-img right" src={cayoLargo} />
              </div>
            </div>
            <div className="ar-section">
              <div className="ar-section-title right">Generation Gives</div>
              <div className="ar-section-body">
                <img className="ar-section-img left" src={gGivesTeam} />
                <div className="ar-section-text">
                  {/* Generation Gives is a collective effort of professionals and volunteers deployed during disaster relief services who leverage modern technology, logistics experience, and a knowledge network to improve economic and physical environments through recovery. After the devastating effects of Hurricane Maria, Generation Gives volunteers provided crucial internet services to turn on the first working ATMs, provided satellite connectivity to grocery stores, and distributed Garmin communication devices and other equipment to local aid workers. In January 2018 Generation Gives volunteers returned to Vieques to light up the entire island with satellite internet, providing free internet to all the local schools with annual subscriptions to modern educational programs that the community has never been exposed to before. Still, the work is yet to be completed, learn more and take action. Today matters! */}
                  Generation Gives, the developer of PRFerry,org, is a
                  collective effort of professionals and volunteers deployed
                  during disaster relief services who leverage modern
                  technology, logistics experience, and a knowledge network to
                  improve economic and physical environments through recovery.
                  <br />
                  <br />
                  After the devastating effects of Hurricane Maria, Generation
                  Gives volunteers provided crucial internet services to turn on
                  the first working ATMs, provided satellite connectivity for
                  food purchases, and distributed Garmin communication devices
                  and other equipment to local aid workers.
                  <br />
                  <br />
                  Our volunteers continue to return to Vieques and Culebra
                  regularly as recovery and preparedness efforts continue and
                  have witnessed challenges the communities face due to
                  consistent uncertainty of the ferry service. For the residents
                  living in these communities, ferry routes are the only option
                  to access critical services found off the islands.
                  <br />
                  <br />
                  We invested and created the PRFerry.org page to track and
                  report on the position of any ferry ensuring this critical
                  information is available to every resident as easily as
                  possible. To contribute to keep PRFerry.org possible please
                  visit{" "}
                  <a href="https://generationgives.org">Generation Gives</a> and
                  pledge your support.
                  {/* <br/><br/>  */}
                  {/* <a className="visit-link" href="https://generationgives.org">Visit Generation Gives!</a> */}
                </div>
              </div>
            </div>
            <div className="ar-section terms">
              <div
                className="ar-section-title terms right"
                onClick={this.showTerms}
              >
                Terms and Conditions
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  },
  componentDidMount: function () {
    //console.log(window.L);
    //var zm = window.innerWidth < 600 ? 10 : 11;
    //window.testSetIcon = this.testSetIcon;
    window.createSub = this.createSub;
    window.initializeSub = this.initializeSub;

    var zm = 10;
    var mm = document.getElementById("mymap");
    // mm.style["height"] = "40vh";
    // mm.style["width"] = "100vw";
    var mymap = window.L.map("mymap").setView([18.19934, -65.450159], zm);

    window.L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution:
          '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
        tileSize: 512,
        maxZoom: 18,
        zoomOffset: -1,
        id: "mapbox/streets-v11",
        accessToken:
          "pk.eyJ1IjoidXBhc3VuIiwiYSI6ImNqc2g2dnMwYzBrbXo0M3FnczB1YWxkMWMifQ.Ay5v7ItPT_7CKclFroGi8w",
      }
    ).addTo(mymap);

    // window.L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
    //   attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a> | <a href="https://bl.ocks.org/wboykinm/599cf6a879bcd7befb326fe0b4833e5f">Compass Rose</a> by Bill Morris',
    //   maxZoom: 18,
    //   id: 'mapbox.streets',
    //   accessToken: 'pk.eyJ1IjoidXBhc3VuIiwiYSI6ImNqc2g2dnMwYzBrbXo0M3FnczB1YWxkMWMifQ.Ay5v7ItPT_7CKclFroGi8w'
    // }).addTo(mymap);

    // mymap.on('zoomend', function() {
    //     if(this.state.boatList && this.state.boatMap) {
    //       this.flipBoats();
    //     }
    // }.bind(this));

    // window.L.tileLayer('https://tile.thunderforest.com/neighbourhood/{z}/{x}/{y}.png?apikey=7273a50d3ef741409813df20e5983d14', {
    //   attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.thunderforest.com/">Thunderforest</a>',
    //   maxZoom: 18
    // }).addTo(mymap);

    //MCUtil.sendXHR("https://s3.amazonaws.com/viequesferry.org/ps02SimpleResponse.json", null, "GET", "application/json", after.bind(this), null, "Initial Ferry Data Fetch", null);

    MCUtil.sendXHR(
      getFerryPositionsUrl,
      null,
      "GET",
      "application/json",
      after.bind(this),
      null,
      "Test Ferry Data Fetch",
      null
    );

    this.buildCompass();

    function test(xhr) {
      var resp = JSON.parse(xhr.response);
    }

    function after(xhr) {
      var resp = JSON.parse(xhr.response);
      var decodedResp = this.responseDecoder(resp);
      var boatList = decodedResp.sResp;
      var boatMap = this.toMap(boatList);
      console.log(boatList);

      var siArr = this.initializeShipMarkers(boatList, mymap, boatMap);
      var portMarkers = this.initializePortMarkers(mymap);
      var portList = decodedResp.pResp;

      this.setState(
        {
          mounted: true,
          boatList: boatList,
          boatMap: boatMap,
          worldMap: mymap,
          boatIconArr: siArr,
          portIconArr: portMarkers,
          portList: portList,
        },
        this.startFetchInterval
      );
    }
  },
  getColor: function (mmsi) {
    switch (parseInt(mmsi)) {
      case 338173000:
        return "#795448";
      case 368237000:
        return "#007f01";
      case 367618070:
        return "#007f01";
      case 366915910: // bigcat express
        return "#800000";
      case 367481080: // mr.mason
        return "#800000";
      case 367547820:
        return "#fe8b9f";
      case 368038790:
        return "#f00";
      case 367618240:
        return "#ffd701"; //mr evan
      case 368106360:
        return "#ffd701"; //coastal explorer
      case 367617270:
        return "#fe8b9f";
      case 368087510:
        return "#fe8b9f";
      case 368037610:
        return "#795448";
      case 368038080:
        return "#007f01";
      case 367396890:
        return "#fe8b9f";
      case 367757210:
        return "#fe8b9f";
      case 367179790:
        return "#007f01";
      case 368054610:
        return "#800000";
      case 368014910:
        return "#795448";
      case 367495520:
        return "#fe8b9f";
      case 367617230:
        return "#fe8b9f";
      case 368404080:
        return "#007f01";
    }
  },
  setCompassNeedle: function (boat) {
    var mp = d3.select("#markerPath");
    var line = d3.select("#compassLine");
    var col = this.getColor(boat.MMSI);
    if (boat.SPEED > 1 && boat.COURSE <= 360) {
      mp.style("fill", col);
      line
        .attr("stroke", col)
        .style("transform", "rotate(" + boat.COURSE + "deg)");
    } else {
      col = "#ffffff00";
      mp.style("fill", col);
      line.attr("stroke", col);
    }
  },
  buildCompass: function () {
    var height = 150;
    var width = 150;
    var radius = 75 / 2;
    var interact = radius * 0.7;
    var pad = radius * 0.25;

    var svg = d3
      .select("#compass")
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g");

    svg
      .append("svg")
      .append("marker")
      .attr("id", "arrow")
      .attr("markerUnits", "strokeWidth")
      .attr("markerWidth", "12")
      .attr("markerHeight", "12")
      .attr("viewBox", "0 0 12 12")
      .attr("refX", "6")
      .attr("refY", "6")
      .attr("orient", "auto")
      .append("path")
      .attr("d", "M2,2 L10,6 L2,10 L6,6 L2,2")
      .style("fill", "#ffffff00")
      .attr("id", "markerPath");

    // build the intercardinal winds
    svg
      .append("circle")
      .attr("class", "arc-minor")
      .attr("cx", width / 2 - interact)
      .attr("cy", height / 2)
      .attr("r", interact);

    svg
      .append("circle")
      .attr("class", "arc-minor")
      .attr("cx", width / 2)
      .attr("cy", height / 2 + interact)
      .attr("r", interact);

    svg
      .append("circle")
      .attr("class", "arc-minor")
      .attr("cx", width / 2)
      .attr("cy", height / 2 - interact)
      .attr("r", interact);

    svg
      .append("circle")
      .attr("class", "arc-minor")
      .attr("cx", width / 2 + interact)
      .attr("cy", height / 2)
      .attr("r", interact);

    // build the cardinal winds
    svg
      .append("circle")
      .attr("class", "arc")
      .attr("cx", width / 2 - interact)
      .attr("cy", height / 2 - interact)
      .attr("r", radius);

    svg
      .append("circle")
      .attr("class", "arc")
      .attr("cx", width / 2 + interact)
      .attr("cy", height / 2 - interact)
      .attr("r", radius);

    svg
      .append("circle")
      .attr("class", "arc")
      .attr("cx", width / 2 - interact)
      .attr("cy", height / 2 + interact)
      .attr("r", radius);

    svg
      .append("circle")
      .attr("class", "arc")
      .attr("cx", width / 2 + interact)
      .attr("cy", height / 2 + interact)
      .attr("r", radius);

    // add mask
    svg
      .append("circle")
      .attr("class", "mask")
      .attr("cx", width / 2)
      .attr("cy", height / 2)
      .attr("r", 53 + 100);

    // build the outer circle
    svg
      .append("circle")
      .attr("class", "arc-heavy")
      .attr("cx", width / 2)
      .attr("cy", height / 2)
      .attr("r", 53);

    // build the outer toposcope ring
    svg
      .append("circle")
      .attr("class", "arc-heavy")
      .attr("cx", width / 2)
      .attr("cy", height / 2)
      .attr("r", 60.5);

    svg
      .append("line")
      .attr("x1", 75)
      .attr("y1", 75)
      .attr("x2", 75)
      .attr("y2", 30)
      .attr("stroke", "#ffffff00")
      .attr("stroke-width", 2)
      .attr("id", "compassLine")
      .attr("marker-end", "url(#arrow)")
      .style("transition", "transform 0.2s")
      .style("transform", "rotate(0deg)")
      .style("transform-origin", "75px 75px");

    // build the toposcope locations
    var locations = [
      {
        name: "middlebury",
        bearing: 238,
      },
      {
        name: "vuelta larga",
        bearing: 175,
      },
      {
        name: "boston",
        bearing: 162,
      },
      {
        name: "harwichport",
        bearing: 152,
      },
      {
        name: "mont albert",
        bearing: 40,
      },
      {
        name: "central city",
        bearing: 270,
      },
    ];

    // for (var i = 0; i < locations.length; i++) {
    //   var outerRadius = 113.5;
    //   var rads = (locations[i].bearing - 90) * Math.PI / 180;
    //   var x = Math.cos(rads) * outerRadius + (width/2);
    //   var y = Math.sin(rads) * outerRadius + (width/2);
    //   svg.append("circle")
    //     .attr("class", "location")
    //     .attr("cx", x)
    //     .attr("cy", y)
    //     .attr("r", 7.5);
    // }

    // labels
    svg
      .append("text")
      .attr("class", "direction")
      .attr("y", pad)
      .attr("x", width / 2)
      .style("font-size", "10px")
      .text("N");
  },
  startFetchInterval: function () {
    if (this.state.boatList.length > 0) {
      this.setCompassNeedle(this.state.boatList[0]);
    }

    this.ferryDataFetchInterval = window.setInterval(
      function () {
        MCUtil.sendXHR(
          getFerryPositionsUrl,
          null,
          "GET",
          "application/json",
          after.bind(this),
          null,
          null,
          null
        );

        function after(xhr) {
          var resp = JSON.parse(xhr.response);
          var decodedResp = this.responseDecoder(resp);
          var boatList = decodedResp.sResp;
          var portList = decodedResp.pResp;

          console.log("Ferry Data Refetch - ", boatList);

          this.reMap(boatList, this.state.boatMap);

          this.setState({
            boatList: this.state.boatList,
            boatMap: this.state.boatMap,
            boatIconArr: this.state.boatIconArr,
            portList: portList,
          });
        }
      }.bind(this),
      1000 * 60
    );
  },
  toMap: function (list) {
    //as in to hashmap
    var map = {};
    for (var i = 0; i < list.length; i++) {
      map[list[i].MMSI] = { boat: list[i], ind: i };
    }
    return map;
  },
  testSetIcon: function () {
    var ShipIcon = window.L.Icon.extend({
      options: {
        iconSize: [15, 20],
        iconAnchor: [7, 10],
        popupAnchor: [0, -10],
      },
    });

    for (var i = 0; i < this.state.boatList; i++) {
      var bmItem = this.state.boatMap[this.state.boatList[i].MMSI];
      var boat = this.state.boatList[i];
      var m = bmItem.icon;
      var n = new ShipIcon({
        iconUrl: this.assignIcon(boat.MMSI, boat.COURSE),
      });
      m.setIcon(n);
    }
  },
  reMap: function (boatList, boatMap) {
    var ShipIcon = window.L.Icon.extend({
      options: {
        iconSize: [15, 20],
        iconAnchor: [7, 10],
        popupAnchor: [0, -10],
      },
    });

    for (var i = 0; i < boatList.length; i++) {
      var bmItem = boatMap[boatList[i].MMSI];
      if (!bmItem) {
        bmItem = this.trackNewBoat(boatList[i]);
        continue;
      }

      bmItem.boat = boatList[i];
      this.state.boatList[bmItem.ind] = boatList[i];

      if (this.state.selectedBoat == bmItem.ind) {
        this.setCompassNeedle(bmItem.boat);
      }

      var m = bmItem.icon;
      var n = new ShipIcon({
        iconUrl: this.assignIcon(bmItem.boat.MMSI, bmItem.boat.COURSE),
      });
      m.setIcon(n);

      var initLat = parseFloat(bmItem.boat.LAT);
      var initLon = parseFloat(bmItem.boat.LON);

      //console.log("moving marker - ", initLat + latChange, initLon + lonChange);
      m.setLatLng([parseFloat(initLat), parseFloat(initLon)]);
    }

    return boatMap;
  },
  flipBoats: function () {
    var boats = this.state.boatList;
    for (var i = 0; i < boats.length; i++) {
      var boat = boats[i];
      var bmItem = this.state.boatMap[boat.MMSI];
      var m = bmItem.icon;

      if (boat.COURSE > 180) {
        var t = m._icon.style["transform"];
        if (t.indexOf("scaleX(-1)") < 0) {
          t += " scaleX(-1)";
          m._icon.style["transform"] = t;
          m._icon.style["left"] = "15px";
        }
      } else {
        var t = m._icon.style["transform"];
        if (t.indexOf("scaleX(-1)") > 0) {
          t.split(" ");
          t.splice(t.indexOf("scaleX(-1)"), 1);
          t.join(" ");
          m._icon.style["transform"] = t;
          m._icon.style["left"] = "0px";
        }
      }
    }
  },
  trackNewBoat: function (newItem) {
    this.state.boatList.push(newItem);
    this.state.boatMap[newItem.MMSI] = {
      boat: newItem,
      ind: this.state.boatList.length - 1,
    };
    this.addBoatMarker(newItem);
  },
  addBoatMarker: function (newItem) {
    var ShipIcon = window.L.Icon.extend({
      options: {
        iconSize: [15, 20],
        iconAnchor: [7, 10],
        popupAnchor: [0, -8],
      },
    });

    var n = new ShipIcon({
      iconUrl: this.assignIcon(newItem.MMSI, newItem.COURSE),
    });

    var m = window.L.marker(
      [parseFloat(newItem.LAT), parseFloat(newItem.LON)],
      { icon: n }
    )
      .addTo(this.state.worldMap)
      .bindPopup(newItem.SHIP_NAME);
    this.state.boatIconArr.push(m);
    m.on(
      "click",
      this.boatMarkerClick.bind(this, this.state.boatIconArr.length - 1)
    );
    this.state.boatMap[newItem.MMSI].icon = m;
  },
  initializeShipMarkers: function (boatList, map, boatMap) {
    var sIcons = [
      ship_brown,
      ship_green,
      ship_maroon,
      ship_yellow,
      ship_pink,
      ship_red,
    ];
    var siArr = [];
    var ShipIcon = window.L.Icon.extend({
      options: {
        iconSize: [15, 20],
        iconAnchor: [7, 10],
        popupAnchor: [0, -8],
      },
    });

    for (var i = 0; i < boatList.length; i++) {
      var n = new ShipIcon({
        iconUrl: this.assignIcon(boatList[i].MMSI, boatList[i].COURSE),
      });
      var m = window.L.marker(
        [parseFloat(boatList[i].LAT), parseFloat(boatList[i].LON)],
        { icon: n }
      )
        .addTo(map)
        .bindPopup(boatList[i].SHIP_NAME);

      siArr.push(m);
      boatMap[boatList[i].MMSI].icon = m;
      m.on("click", this.boatMarkerClick.bind(this, i));
      // window.L.marker([parseFloat(td[i].LAT)+0.02, parseFloat(td[i].LON)+0.02], {icon: n}).addTo(map).bindPopup("I am a boat.");
    }
    window.siArr = siArr;
    return siArr;
  },
  boatMarkerClick: function (ind) {
    console.log(this.state.boatList[ind]);
    var b = this.state.boatList[ind];
    var latLon = [this.state.boatList[ind].LAT, this.state.boatList[ind].LON];
    var zl = this.state.worldMap.getZoom();
    this.state.boatIconArr[ind].openPopup();
    this.state.worldMap.setView(latLon, 12 > zl ? 12 : zl);
    this.setCompassNeedle(b);
    this.setState({
      selectedBoat: ind,
      selectionType: "boat",
    });
  },
  initializePortMarkers: function (map) {
    //18.152183, -65.442961
    var PortIcon = window.L.Icon.extend({
      options: {
        iconSize: [15, 20],
        iconAnchor: [7, 10],
        popupAnchor: [0, -10],
      },
    });

    var vPort = new PortIcon({ iconUrl: portAnchor });

    var pm = [];
    pm.push(
      window.L.marker([18.152183, -65.442961], { icon: vPort })
        .addTo(map)
        .bindPopup("Vieques Ferry Terminal.")
    );
    pm.push(
      window.L.marker([18.300929, -65.302405], { icon: vPort })
        .addTo(map)
        .bindPopup("Terminal de Lanchas de Culebra.")
    );
    pm.push(
      window.L.marker([18.230016, -65.618434], { icon: vPort })
        .addTo(map)
        .bindPopup("Ceiba Ferry Terminal.")
    );
    pm.push(
      window.L.marker([18.333721, -65.629575], { icon: vPort })
        .addTo(map)
        .bindPopup("Fajardo Ferry Terminal.")
    );
    pm.push(
      window.L.marker([18.463209, -66.113164], { icon: vPort })
        .addTo(map)
        .bindPopup("Muelle De Viejo San Juan Ferry Terminal.")
    );

    for (var i = 0; i < pm.length; i++) {
      // pm[i].on("click", this.moveMapTo.bind(this,pm[i].getLatLng(),null,true));
      pm[i].on("click", this.selectPort.bind(this, parseInt(i.toString())));
    }

    return pm;
  },
  selectPort: function (ind) {
    this.setState({
      selectionType: "port",
      selectedPort: ind,
    });
    this.moveMapTo(this.state.portIconArr[ind].getLatLng(), 14);
  },
  moveMapTo: function (latLng, zm, isPort) {
    this.state.worldMap.setView(latLng, zm ? zm : 12);
    if (isPort) {
      this.setState({
        selectionType: "port",
      });
    }
  },
  isStale: function (boat) {
    return (
      moment().diff(moment(boat.TIMESTAMP_ORIGINAL + "-0000")) / (60 * 1000)
    );
  },
  convertTimestamp: function (ts, timeonly) {
    if (!ts) {
      return null;
    }
    var m = moment(ts + "-0000").tz("America/Puerto_Rico");
    return timeonly ? m.format("h:mm a") : m.format("MMMM Do, h:mm a");
  },
  responseDecoder: function (resp) {
    var sResp = [];
    var pMapObj = {
      inbound: [],
      docked: [],
      outbound: [],
      name: "",
    };

    function createNewPMapObj(pmoName) {
      var npmo = pMapObj.clone();
      npmo.name = pmoName;
      return npmo;
    }

    var pMap = {
      ViequesFerryTerminal: createNewPMapObj("Vieques Ferry Terminal"),
      CeibaFerryTerminal: createNewPMapObj("Ceiba Ferry Terminal"),
      FajardoFerryTerminal: createNewPMapObj("Fajardo Ferry Terminal"),
      TerminaldeLanchasdeCulebra: createNewPMapObj(
        "Terminal de Lanchas de Culebra"
      ),
      MuelleDeViejoSanJuanFerryTerminal: createNewPMapObj(
        "Muelle De Viejo San Juan Ferry Terminal"
      ),
    };

    for (var i = 0; i < resp.length; i++) {
      var s = {};

      var ship = resp[i];

      s.MMSI = ship["mmsi"];
      s.LAT = ship["lat"];
      s.LON = ship["lng"];
      s.SPEED = ship["speed"];
      s.COURSE = ship["course"];
      s.TIMESTAMP = ship["timestamp"];
      s.SHIP_NAME = ship["shipname"];
      s.ATPORT = ship["atPort"];
      s.TOPORT = ship["toPort"];
      s.STARTTIME = ship["startTime"];
      s.ETAMIN = ship["etaMin"];
      s.ETAMAX = ship["etaMax"];
      s.CURRENTTRIPSTEP = ship["currentTripStep"];

      s.TIMESTAMP_ORIGINAL = s.TIMESTAMP;
      s.STARTTIME_ORIGINAL = s.STARTTIME;
      s.ETAMIN_ORIGINAL = s.ETAMIN;
      s.ETAMAX_ORIGINAL = s.ETAMAX;

      s.TIMESTAMP = this.convertTimestamp(s.TIMESTAMP);
      s.STARTTIME = this.convertTimestamp(s.STARTTIME);
      s.ETAMIN = this.convertTimestamp(s.ETAMIN, true);
      s.ETAMAX = this.convertTimestamp(s.ETAMAX, true);

      if (s.CURRENTTRIPSTEP > 0) {
        var pin = pMap[s.TOPORT.replace(/\s/g, "")];
        if (!pin) {
          pin = pMapObj.clone();
          pMap[s.TOPORT.replace(/\s/g, "")] = pdocked;
        }

        pin.inbound.push({
          shipname: s.SHIP_NAME,
          starttime: s.STARTTIME,
          etamin: s.ETAMIN,
          etamax: s.ETAMAX,
          mmsi: s.MMSI,
        });

        var pout = pMap[s.ATPORT.replace(/\s/g, "")];
        if (!pout) {
          pout = pMapObj.clone();
          pMap[s.TOPORT.replace(/\s/g, "")] = pout;
        }

        pout.outbound.push({
          shipname: s.SHIP_NAME,
          starttime: s.STARTTIME,
          etamin: s.ETAMIN,
          etamax: s.ETAMAX,
          mmsi: s.MMSI,
          toport: s.TOPORT,
        });
      } else if (s.CURRENTTRIPSTEP == 0) {
        var pdocked = pMap[s.ATPORT.replace(/\s/g, "")];
        if (!pdocked) {
          pdocked = pMapObj.clone();
          pMap[s.ATPORT.replace(/\s/g, "")] = pdocked;
        }

        pdocked.docked.push({
          shipname: s.SHIP_NAME,
          starttime: s.STARTTIME,
          etamin: s.ETAMIN,
          etamax: s.ETAMAX,
          mmsi: s.MMSI,
        });
      }

      sResp.push(s);
    }

    var pResp = [
      pMap.ViequesFerryTerminal,
      pMap.TerminaldeLanchasdeCulebra,
      pMap.CeibaFerryTerminal,
      pMap.FajardoFerryTerminal,
      pMap.MuelleDeViejoSanJuanFerryTerminal,
    ];

    console.log(pResp);

    return { sResp: sResp, pResp: pResp };
  },
  getStatus: function (s) {
    switch (s) {
      case 0:
        return "Under way using engine";
      case 1:
        return "At anchor";
      case 2:
        return "not under command";
      case 3:
        return "restricted maneuverability";
      case 4:
        return "constrained by her draught";
      case 5:
        return "Moored";
      case 6:
        return "Aground";
      case 7:
        return "Engaged in fishing";
      case 8:
        return "Under way sailing";
      case 9:
        return "";
      case 10:
        return "";
      case 11:
        return "power-driven vessel towing astern (regional use)";
      case 12:
        return "power-driven vessel pushing ahead or towing alongside (regional use)";
    }
  },
  assignName: function (mmsi) {
    switch (parseInt(mmsi)) {
      case 338173000:
        return "Mr. Cade";
      case 368237000:
        return "Cayo Largo";
      case 367618070:
        return "Cayo Blanco";
      case 366915910:
        return "Big Cat Express";
      case 367481080:
        return "Mr. Mason";
      case 367547820:
        return "Isla Bonita";
      case 368038790:
        return "Schoodic Explorer";
      case 367618240:
        return "Mr. Evan";
      case 368106360:
        return "Coastal Explorer";
      case 367617270:
        return "Isleno";
      case 368087510:
        return "Julia Leigh";
      case 368037610:
        return "Breezy Point";
      case 368038080:
        return "Summer Wind";
      case 367396890:
        return "Mitchel";
      case 367757210:
        return "Don Jamie";
      case 367179790:
        return "Lady Eve";
      case 368054610:
        return "Straits Express";
      case 368014910:
        return "Aurora";
      case 367495520:
        return "Mr. Row";
      case 367617230:
        return "Santa Maria";
      case 368404080:
        return "La Borinquena";
    }
  },
  assignIcon: function (mmsi, c) {
    switch (parseInt(mmsi)) {
      case 338173000:
        return c > 180 ? ship_brown_flip : ship_brown;
      case 368237000:
        return c > 180 ? ship_green_flip : ship_green; //cayo largo
      case 367618070:
        return c > 180 ? ship_green_flip : ship_green; //cayo blanco
      case 366915910:
        return c > 180 ? ship_maroon_flip : ship_maroon; //bigcat express
      case 367481080:
        return c > 180 ? ship_maroon_flip : ship_maroon; //mr mason
      case 367547820:
        return c > 180 ? ship_pink_flip : ship_pink;
      case 368038790:
        return c > 180 ? ship_red_flip : ship_red;
      case 367618240:
        return c > 180 ? ship_yellow_flip : ship_yellow; //mr evan
      case 368106360:
        return c > 180 ? ship_yellow_flip : ship_yellow; //coastal explorer
      case 367617270:
        return c > 180 ? ship_pink_flip : ship_pink;
      case 368087510:
        return c > 180 ? ship_red_flip : ship_red;
      case 368037610:
        return c > 180 ? ship_brown_flip : ship_brown;
      case 368038080:
        return c > 180 ? ship_green_flip : ship_green;
      case 367396890:
        return c > 180 ? ship_pink_flip : ship_pink;
      case 367757210:
        return c > 180 ? ship_pink_flip : ship_pink;
      case 367179790:
        return c > 180 ? ship_green_flip : ship_green;
      case 368054610:
        return c > 180 ? ship_maroon_flip : ship_maroon;
      case 368014910:
        return c > 180 ? ship_brown_flip : ship_brown;
      case 367495520:
        return c > 180 ? ship_pink_flip : ship_pink;
      case 367617230:
        return c > 180 ? ship_red_flip : ship_red;
      case 368404080:
        return c > 180 ? ship_green_flip : ship_green;
      default:
        var sIcons = [
          ship_brown,
          ship_green,
          ship_maroon,
          ship_yellow,
          ship_pink,
          ship_red,
        ];
        return sIcons[Math.floor(Math.random() * 6)];
    }
  },
});

export default App;



// WEBPACK FOOTER //
// ./src/App.js